<template>
  <list-view :thead="['Perubahan', 'Tanggal Mutasi', 'Tanggal Perubahaan']">
    <template v-slot:tbody>
      <tr v-if="logsync.length < 1">
        <td colspan="4" class="text-center text-secondary">Tidak ada data</td>
      </tr>
      <tr class="box-updated" v-for="(item, index) in logsync" :key="index">
        <td>
            <table class="table box-updated__table">
              <thead>
                <th></th>
                <th>data lama</th>
                <th>data baru</th>
              </thead>
              <tbody class="border-0" v-for="(field) in Object.keys(item.old).filter((itm) => {
                return itm != 'last_mutation_date';
              })" :key="field">
                <tr class="border-0">
                    <td>{{ field }}</td> 
                    <td class="align-top">
                      <div class="d-flex gap-2">
                        {{ subfield }}
                        <argon-badge color="secondary">{{ String(typeof item.old?.[field]) == "string" ?
                          item.old?.[field] : (item.old?.[field]?.name ?? "") }}</argon-badge>
                      </div>
                    </td>
                    <td>
                        <argon-badge color="success">{{ String(typeof item.new?.[field]) == "string" ? item.new?.[field] :
                          item.new?.[field]?.name }}</argon-badge>
                    </td>
                  </tr>
              </tbody>
            </table>
        </td>
        <td>
          <span class="text-sm" v-if="this.convertToMoment(item?.new?.last_mutation_date ?? null, 'DD MMMM YYYY')">{{ `${this.convertToMoment(item?.new?.last_mutation_date ?? null, "DD MMMM YYYY")}` }}</span>
        </td>
        <td>
          <span class="text-sm" v-if="this.convertToMoment(item.created_at ?? null, 'DD MMMM YYYY HH:mm')">{{ `${this.convertToMoment(item.created_at ?? null, "DD MMMM YYYY HH:mm")} WIB` }}</span>
        </td>
      </tr>
    </template>
  </list-view>
</template>

<script>
import ListView from '@/components/ListView.vue'
import ArgonBadge from '../../../components/ArgonBadge.vue'
export default {
  name: "ListViewLogSync",
  props: {
    logsync: {
      type: Array,
      required: true,
    }
  },
  components: {
    ListView,
    ArgonBadge
  }
}
</script>


<style scoped>
.box-updated {
  border-bottom: 10px solid white;
}
.box-updated td {
  background-color: #f5faff;
}

.box-updated__table th {
  border: none;
  padding-left: 8px;
}
.box-updated .badge-secondary {
  color: #92a8b9;
}
</style>